import * as React             from 'react';
import * as PropTypes         from 'prop-types';

interface ConversationTypeFilterProps {
    handleChangeFilter?: (event: React.SyntheticEvent<{value: string}>) => void;
    filterState: string;
}

const ConversationTypeFilter: React.StatelessComponent<ConversationTypeFilterProps> = ({ handleChangeFilter, filterState }, { translate }) => (
    <div className="conversationTypeFilter">
        <div className="conversationTypeFilter_inputGroup">
            <input className="conversationTypeFilter_input" type="radio" id="own" value="own" onChange={handleChangeFilter} checked={filterState === 'own'} />
            <label className="conversationTypeFilter_label" htmlFor="own">{translate('my_chat')}</label>
        </div>
        <div className="conversationTypeFilter_inputGroup">
            <input className="conversationTypeFilter_input" type="radio" id="outletManager" value="outlet_manager" onChange={handleChangeFilter} checked={filterState === 'outlet_manager'}/>
            <label className="conversationTypeFilter_label" htmlFor="outletManager">{translate('all_chat')}</label>
        </div>
    </div>
);

export default ConversationTypeFilter;

ConversationTypeFilter.contextTypes = {
    translate: PropTypes.func.isRequired
};



// WEBPACK FOOTER //
// ./src/sections/ConversationsList/ConversationTypeFilter.tsx